import React from 'react'
import YoutubeCreditsView from './YoutubeCreditsView'
import type { MeResponse } from '../../api/me'

type YoutubeCreditsPublicPageProps = {
  me?: MeResponse | null
  isLoggedIn: boolean
}

const YoutubeCreditsPublicPage: React.FC<YoutubeCreditsPublicPageProps> = ({ me, isLoggedIn }) => (
  <YoutubeCreditsView variant="public" me={me} isLoggedIn={isLoggedIn} />
)

export default YoutubeCreditsPublicPage
